$(document).ready(function () {
	// Initialize Isotope
	var isotopes = ["product-grid", "faq", "collection"];

	isotopes.forEach((isotope) => {
		if ($(".web3000-isotope-component--" + isotope).length == 0) {
			return;
		}
		var isotopeConfig = {
			itemSelector: ".web3000-isotope__block",
			gutter: 0,
			layoutMode: isotope === "product-grid" ? "fitRows" : "masonry",
			// fitRows: {
            //     gutter: ".gutter-sizer",
			// },
			columnWidth: ".grid-sizer",
            percentPosition: true,
		};

		var $grid = $(".web3000-isotope-component--" + isotope + " .web3000-isotope").isotope(isotopeConfig);

		function setResponsiveIsotope1() {
			var windowWidth = window.innerWidth;

			if (windowWidth > 1023 && isotope === "collection") {
				$grid.options.layoutMode = "fitRows";
			} else {
				$grid.options.layoutMode = "masonry";
			}

			// Trigger a layout update
			$grid.arrange();
		}

		function setResponsiveIsotope() {
			var windowWidth = window.innerWidth;

			/* Fix 07/2026: "product-grid" laeuft jetzt auf ALLEN Breiten in "fitRows",
			   damit die Kacheln zeilenweise oben buendig ausgerichtet sind.
			   Vorher fiel die Produktuebersicht mobil in "masonry" und die Spalten
			   verschoben sich bei unterschiedlich langen Titeln/Preisen. */
			var newLayoutMode;
			if (isotope === "product-grid") {
				newLayoutMode = "fitRows";
			} else if (isotope === "collection") {
				newLayoutMode = windowWidth > 1023 ? "fitRows" : "masonry";
			} else {
				newLayoutMode = "masonry";
			}

			// Only update layoutMode if it has changed
			if ($grid.data("isotope").options.layoutMode !== newLayoutMode) {
				$grid.isotope("option", { layoutMode: newLayoutMode });

				// Trigger a layout update
				$grid.isotope("layout");
			}
		}

		// Call the function once to set initial layout mode
		setResponsiveIsotope();

		// Call the function on window resize
		window.addEventListener("resize", setResponsiveIsotope);

		// Layout update after images are loaded
		$grid.imagesLoaded().progress(function () {
			setResponsiveIsotope();
		});

        $grid.imagesLoaded().done(function () {
			setResponsiveIsotope();
			$(window).trigger("resize");
		});

		/* Fix 10/2026: Der gesetzte Filter steht jetzt in der Adresse, z. B.
		   /collections/all?filter=sets. Damit laesst sich die Uebersicht mit
		   vorgewaehltem Filter verlinken und teilen; ein Neuladen wirft die
		   Auswahl nicht mehr weg. Nur fuer die Produktraster, die FAQ-Filter
		   bleiben wie bisher ohne Spur in der Adresse. */
		var filterInAdresse = isotope !== "faq";

		function filterInAdresseMerken(wert) {
			if (!filterInAdresse || !window.history || !window.history.replaceState) {
				return;
			}
			try {
				var adresse = new URL(window.location.href);
				if (wert) {
					adresse.searchParams.set("filter", wert);
				} else {
					adresse.searchParams.delete("filter");
				}
				window.history.replaceState(null, "", adresse.pathname + adresse.search + adresse.hash);
			} catch (e) {
				/* Browser ohne URL-Objekt: Adresse bleibt einfach unveraendert */
			}
		}

		/* Beim Laden den Filter aus der Adresse uebernehmen. Der Wert ist der
		   handleisierte Kollektionstitel, also derselbe wie in data-value.
		   Umgesetzt ueber einen echten Klick, damit es nur einen Weg gibt,
		   auf dem ein Filter gesetzt wird. */
		function filterAusUrlUebernehmen() {
			if (!filterInAdresse) {
				return;
			}
			var wert;
			try {
				wert = new URL(window.location.href).searchParams.get("filter");
			} catch (e) {
				return;
			}
			if (!wert || !/^[a-z0-9-]+$/.test(wert)) {
				return;
			}
			var $knopf = $(".web3000-isotope-component--" + isotope + " .web3000-filter-button[data-value='" + wert + "']");
			if ($knopf.length && !$knopf.hasClass("is-selected")) {
				$knopf.trigger("click");
			}
		}

		// Filter items when filter button is clicked
		$(".web3000-isotope-component--" + isotope + " .web3000-filter-panel .web3000-filter-button").on("click", function () {
			if ($(this).hasClass("is-selected")) {
				$(this).removeClass("is-selected");
				$grid.isotope({ filter: "*" });
				filterInAdresseMerken(null);
			} else {
				$(".web3000-isotope-component--" + isotope + " .web3000-filter-button").removeClass("is-selected");
				$(this).addClass("is-selected");
				var filterValue = $(this).attr("data-value");
				$grid.isotope({ filter: '[data-group~="' + filterValue + '"]' });
				filterInAdresseMerken(filterValue);
			}
		});

		/* Bewusst hier und nicht in imagesLoaded().done(): "done" feuert nur,
		   wenn alle Bilder erfolgreich geladen sind. Ein einziges fehlerhaftes
		   Bild haette den Link-Filter sonst stumm verschluckt. Isotope ist an
		   dieser Stelle laengst initialisiert, nachladende Bilder loesen
		   ohnehin ein erneutes Layout aus. */
		filterAusUrlUebernehmen();
	});
});
